import { cn } from '~/lib/utils';
import styles from './WidgetCard.module.css';

export interface KeyPointsCardProps {
  className?: string;
  title?: string;
  text?: string;
}

export const KeyPointsCard = ({
  className,
  title = 'Key Points',
  text = 'Velocity up 22%, auth redesign shipped, 3 bugs carried over to next sprint',
}: KeyPointsCardProps) => {
  return (
    <div className={cn(styles.card, styles.cardYellow, className)}>
      <p className={cn(styles.title, styles.titleYellow)}>{title}</p>
      <p className={cn(styles.text, styles.textYellow)}>{text}</p>
    </div>
  );
};

KeyPointsCard.displayName = 'KeyPointsCard';
